import { Application } from "stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const app = Application.start();

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(app, controllers);
